import { logEvent } from "firebase/analytics";
import { analytics } from "../firebaseConfig";

/**
 * Registration funnel events for Firebase / GA4.
 * View in GA4: Explore → Funnel exploration, or Events + custom parameters.
 */
export function logRegistrationEvent(eventName, params = {}) {
  if (typeof window === "undefined" || !analytics) return;
  try {
    const safe = {};
    for (const [k, v] of Object.entries(params)) {
      if (v === undefined || v === null) continue;
      const s = typeof v === "string" ? v.slice(0, 100) : v;
      safe[k] = s;
    }
    logEvent(analytics, eventName, safe);
  } catch (_) {
    // ignore analytics failures
  }
}
